import React from "react";
import { Link } from "react-router-dom";

const Header = ({ isAuthenticated, onLogout }) => (
  <header>
    <h1>"Just One More Thing..."</h1>
    <ul className="App-header container">
      <li key="home">
        <Link to="/">Home</Link>
      </li>
      <li>
        <Link to="/episodes">Episodes</Link>
      </li>
      {isAuthenticated ? (
        <>
          <li>
            <Link to="/new">New Post</Link>
          </li>
          <li>
            <button
              className="linkLike"
              onClick={(e) => {
                e.preventDefault();
                onLogout();
              }}
            >
              Logout
            </button>
          </li>
        </>
      ) : (
        <li>
          <Link to="/login">Login</Link>
        </li>
      )}
    </ul>
  </header>
);

export default Header;
